import { ApiResponse } from "../../../types/ApiResponse";
import api from "../../../utils/API";
import { CategoryDTO } from "../dto";
import { Category } from "../entity";

export const getCategory = (): ApiResponse<Category[]> =>
  api.get("/v1/categories");

export const postCategory = (params: CategoryDTO) =>
  api.post("/v1/categories", params);
export const editCategory = ({
  id,
  params,
}: {
  id: string;
  params: CategoryDTO;
}): ApiResponse<{ message: boolean }> =>
  api.put(`/v1/categories/${id}`, params);
export const deleteCategory = (id: string): ApiResponse<{ message: boolean }> =>
  api.delete(`/v1/categories/${id}`);
export const getCategoryById = (id: string): ApiResponse<Category> =>
  api.get(`/v1/categories/${id}`);
